/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Promotion_Benefits_CategoryInputs */

const en_directory_promotion_benefits_category = /** @type {(inputs: Directory_Promotion_Benefits_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Category placement`)
};

const zh_directory_promotion_benefits_category = /** @type {(inputs: Directory_Promotion_Benefits_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`分类展示位置`)
};

/**
* | output |
* | --- |
* | "Category placement" |
*
* @param {Directory_Promotion_Benefits_CategoryInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_promotion_benefits_category = /** @type {((inputs?: Directory_Promotion_Benefits_CategoryInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Promotion_Benefits_CategoryInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_promotion_benefits_category(inputs)
	return zh_directory_promotion_benefits_category(inputs)
});
export { directory_promotion_benefits_category as "directory.promotion.benefits.category" }